import { render, staticRenderFns } from "./News.vue?vue&type=template&id=6e46e898&"
import script from "./News.vue?vue&type=script&lang=js&"
export * from "./News.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/foxik0169/Projects/rattlecinake.com/themes/ultimatefilms/assets/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6e46e898', component.options)
    } else {
      api.reload('6e46e898', component.options)
    }
    module.hot.accept("./News.vue?vue&type=template&id=6e46e898&", function () {
      api.rerender('6e46e898', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Routes/News.vue"
export default component.exports